































import { ExpenseCategory } from "@/api/cost/expense-categories-api";
import { Expense } from "@/api/cost/expenses-api";
import {
  ExpenseSubTotal,
  categorySubTotal,
  itemsSubTotal
} from "@/models/expense";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({ components: {} })
export default class ExpenseSummary extends Vue {
  @Prop({ required: true }) expense!: Expense;

  get expenseCategories(): ExpenseCategory[] {
    return this.$store.state.expenseCategories;
  }

  get importantExpenseCategories(): ExpenseCategory[] {
    return this.expenseCategories.filter(c => c.important);
  }

  get subTotalItems(): ExpenseSubTotal[] {
    return categorySubTotal(itemsSubTotal(this.expense.items));
  }

  get importantSubTotalItems(): ExpenseSubTotal[] {
    return this.importantExpenseCategories.map(category => {
      const item = this.subTotalItems.find(
        item => item.expenseCategoryId === category.id
      );
      if (!item) {
        return {
          expenseCategoryId: category.id,
          name: category.name,
          price: 0
        };
      }
      return { ...item, name: category.name };
    });
  }

  get otherSubTotalItemsCount() {
    return this.subTotalItems.length - this.importantSubTotalItems.length;
  }

  get total(): number {
    return this.expense.items.reduce((s, i) => s + i.unitPrice * i.amount, 0);
  }
}
